var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardwhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 10.4167C2.08325 6.48855 2.08325 4.52397 3.30409 3.30418C4.52492 2.08439 6.48846 2.08334 10.4166 2.08334H14.5833C18.5114 2.08334 20.476 2.08334 21.6958 3.30418C22.9155 4.52501 22.9166 6.48855 22.9166 10.4167V11.4583C22.9166 14.4042 22.9166 15.8781 22.001 16.7927C21.0864 17.7083 19.6124 17.7083 16.6666 17.7083H8.33325C5.38742 17.7083 3.91346 17.7083 2.99888 16.7927C2.08325 15.8781 2.08325 14.4042 2.08325 11.4583V10.4167Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 22.9167H8.33325M12.4999 17.7084V22.9167M22.9166 13.5417H2.08325",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardwhiteIcon);
export default __webpack_public_path__ + "static/media/Dashboard whiteIcon.70e915ae1315d4c839ed4f21891e5968.svg";
export { ForwardRef as ReactComponent };